


import Vue from "vue";
import { Component } from "vue-property-decorator";
import parameters from "@/config/parameters";
import ViewWrapper from "@/components/view-wrapper/ViewWrapper.vue";
import MapReportButton from "@/components/map-report-button/MapReportButton.vue"
import NutsDataService from "@/services/NutsDataService"
import { LatLng, LatLngBounds } from "leaflet";
import {
  LMap,
  LTileLayer,
  LControlLayers,
  LPolyline,
  LControl,
  LControlZoom,
  LFeatureGroup,
  LGeoJson,
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import {
  NutsModel,
  PoliciesModel,
} from "@/models";
import { Feature } from "geojson";

@Component({
  name: "Policies",
  components: {
    ViewWrapper,
    LMap,
    LTileLayer,
    LControlLayers,
    LControl,
    LControlZoom,
    LFeatureGroup,
    LPolyline,
    LGeoJson,
    MapReportButton
  },
})
export default class Policies extends Vue {
  protected nuts0: Array<NutsModel>;
  protected nuts1: Array<NutsModel>;
  protected nuts2: Array<NutsModel>;
  protected nuts3: Array<NutsModel>;

  public loader: boolean;

  readonly tileServer: string;

  bounds: LatLngBounds | null;
  center: LatLng;
  zoom: number;

  tileProviders: {
    attribution: string;
    visible: boolean;
    name: string;
    url: string;
  }[];

  stages: Array<Feature>;

  public focusedElement: null | string;
  public elementToUnfocus: null | string;
  public focusedNUTS0: null | string;
  public focusedNUTS1: null | string;
  public focusedNUTS2: null | string;
  public focusedNUTS3: null | string;
  public focusedPolicies: null | Array<PoliciesModel>;

  public nuts0collapse: boolean;
  public nuts1collapse: boolean;
  public nuts2collapse: boolean;

  constructor() {
    super();

    this.loader = true;

    this.tileServer = parameters.mapConfiguration.tileServer;
    this.zoom = 4;
    this.center = new LatLng(56.85, 4.83); ///56.85/4.83
    this.bounds = null;

    this.stages = [];

    this.tileProviders = [
      {
        attribution: parameters.mapConfiguration.attribution,
        visible: true,
        name: "Thunderforest Atlas",
        url: this.tileServer,
      },
    ];

    this.nuts0 = [];
    this.nuts1 = [];
    this.nuts2 = [];
    this.nuts3 = [];
    this.focusedElement = null;
    this.elementToUnfocus = null;
    this.focusedPolicies = null;
    this.focusedNUTS0 = null
    this.focusedNUTS1 = null
    this.focusedNUTS2 = null
    this.focusedNUTS3 = null

    this.nuts0collapse = true
    this.nuts1collapse = true
    this.nuts2collapse = true
  }

  /* Init map */

  public ready(): void {
    this.bounds = (this.$refs.policiesMap as LMap).mapObject.getBounds();
  }

  /* Map events */

  public zoomUpdated(zoom: number): void {
    this.zoom = zoom;
  }
  public centerUpdated(center: LatLng): void {
    this.center = center;
  }
  public boundsUpdated(bounds: LatLngBounds): void {
    this.bounds = bounds;
  }
  public mapClicked = (): void => {
    // console.log("Map clicked")
  };

  /* Map selection */
  public async onMapElementClicked(codeToFocus: string, nutsLvl: number): Promise<void> {
    this.loader = true;
    this.zoomInCode(codeToFocus);
    this.openListElementCode(codeToFocus, nutsLvl);
    await this.requestNustFromCode(codeToFocus, nutsLvl);
    this.highlightCode(codeToFocus, nutsLvl);
    this.getPoliciesFromCode(codeToFocus, nutsLvl);
    this.loader = false;
  }

  /* List Selection */
  public async onListElementClicked(codeToFocus: string, nutsLvl: number): Promise<void> {
    this.loader = true;
    this.zoomInCode(codeToFocus);
    this.openListElementCode(codeToFocus, nutsLvl);
    await this.requestNustFromCode(codeToFocus, nutsLvl);
    this.highlightCode(codeToFocus, nutsLvl);
    this.getPoliciesFromCode(codeToFocus, nutsLvl);
    this.loader = false;
  }

  /* Request Nuts */
  public async requestNustFromCode(codeToFocus: string, nutsLvl: number): Promise<void> {
    switch (nutsLvl) {
      case 0:
        await NutsDataService.getNuts1(codeToFocus)
            .then((response) => {
              this.nuts1 = response.data
            })
            .catch((e) => {
              console.log(e);
            });
        break;
      case 1:
        await NutsDataService.getNuts2(codeToFocus)
            .then((response) => {
              this.nuts2 = response.data
            })
            .catch((e) => {
              console.log(e);
            });
        break;
      case 2:
        await NutsDataService.getNuts3(codeToFocus)
            .then((response) => {
              this.nuts3 = response.data
            })
            .catch((e) => {
              console.log(e);
            });
        break;
      default:
        break;
    }
    return
  }

  /* Highlighting */
  public zoomInCode(codeToZoomIn: string): void {
    if (this.$refs[codeToZoomIn] && (this.$refs[codeToZoomIn] as LFeatureGroup[])[0].mapObject.getBounds().isValid()) {
      (this.$refs.policiesMap as LMap).mapObject.fitBounds(
        (this.$refs[codeToZoomIn] as LFeatureGroup[])[0].mapObject.getBounds()
      );
    }
  }
  public highlightCode(codeToHighlight: string, nutsLvl: number): void {
    this.elementToUnfocus = this.focusedElement
    if (typeof this.$refs[codeToHighlight] !== "undefined") {
      (
        this.$refs[codeToHighlight] as LFeatureGroup[]
      )[0].mapObject.setStyle(parameters.mapConfiguration.nutsStyle.highlighted);
    }
    this.focusedElement = codeToHighlight; 
    if(nutsLvl==0){
        this.focusedNUTS0 = codeToHighlight;
    } else if(nutsLvl==1){
        this.focusedNUTS1 = codeToHighlight;
    } else if(nutsLvl==2){
        this.focusedNUTS2 = codeToHighlight;
    } else if(nutsLvl==3){
        this.focusedNUTS3 = codeToHighlight;
    } 
  }

  public openListElementCode(codeToFocus: string, nutsLvl: number): void {
    // All the nuts lvl are restored
    if(nutsLvl == 0 && this.focusedNUTS0 !== null) {
      if(this.focusedNUTS2 !== null) {
        this.focusedNUTS2 = null
        this.nuts3 = []
      }
      if(this.focusedNUTS1 !== null) {
        this.focusedNUTS1 = null
        this.nuts2 = []
      }
    } else if(nutsLvl == 1 && this.focusedNUTS1 !== null) {
      if(this.focusedNUTS2 !== null) {
        this.focusedNUTS2 = null
        this.nuts3 = []
      }
    }
    this.focusedNUTS3 = null
  }

  public getPoliciesFromCode(selectedCode: string, nutsLvl: number): void {
    switch (nutsLvl) {
      case 0:
        this.focusedPolicies = this.nuts0.find( ({ code }) => code === selectedCode )?.policies || null
        return
      case 1:
        this.focusedPolicies = this.nuts1.find( ({ code }) => code === selectedCode )?.policies || null
        return
      case 2:
        this.focusedPolicies = this.nuts2.find( ({ code }) => code === selectedCode )?.policies || null
        return
      case 3:
        this.focusedPolicies = this.nuts3.find( ({ code }) => code === selectedCode )?.policies || null
        return
    
      default:
        return;
    }
  }

  public nutsStyle(code: string, nutsLvl: number): Record<string, unknown> {
    if (code == this.focusedElement) { return parameters.mapConfiguration.nutsStyle.highlighted}
    else {return parameters.mapConfiguration.nutsStyle[nutsLvl]}
  }

  public mounted(): void {
    NutsDataService.getNuts0()
      .then((response) => {
        this.nuts0 = response.data
        this.loader = false
      })
      .catch((e) => {
        console.log(e);
      });
  }
}
